export const KOREA_ROAD = `korea_road`
export const NA_ROAD = `na_road`
export const EUROPE_ROAD = `europe_road`
export const JAPAN_ROAD = `japan_road`
export const CHINA_ROAD = `china_road`
export const TAIWAN_ROAD = `taiwan_road`